import api from '../../utils/api';
import { ActivationActions } from '../reducers/activation';
import { alertError, alertSuccess } from './alert';
import { getRetailerSuppliers } from './api/retailers';

const setActivationLoading = (value) => ({ type: ActivationActions.loading, payload: value });

export const getActivationSupplier = (supplierId) => async (dispatch, getState) => {
  dispatch(setActivationLoading({ supplierRetailer: true }));

  try {
    const { retailerId } = getState().role;

    const response = await getRetailerSuppliers(retailerId);
    const suppliersData = response?.data;

    if (suppliersData?.length) {
      const supplierRetailer = suppliersData.find((item) => supplierId === item.supplier.id);
      dispatch({ type: ActivationActions.supplierRetailer, payload: supplierRetailer });
    } else {
      dispatch(alertError(new Error()));
    }
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch(setActivationLoading({ supplierRetailer: false }));
  }
};

export const updatePaymentDetails = (data) => async (dispatch, getState) => {
  const { retailerId } = getState().role;

  try {
    const response = await putCardDetails(retailerId, data);

    if (response.data.success) {
      dispatch(getActivationSupplier(data.supplier_id));
      dispatch(alertSuccess('Success'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

let cancelPutCardDetails;
const putCardDetails = (retailerId, data) => {
  if (cancelPutCardDetails) {
    cancelPutCardDetails('Cancel put card details');
  }

  return api.put(`/retailers/${retailerId}/creditcard`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPutCardDetails = c)),
  });
};

export const setOperatorCommission = (commissionValue) => async (dispatch, getState) => {
  const { activation, role } = getState();
  const { retailerId } = role;
  const {
    supplier: { id: supplierId },
  } = activation;

  setActivationLoading({ commission: true });

  try {
    const response = await api.put(`/retailers/${retailerId}/suppliers/${supplierId}`, {
      operator_commission: commissionValue,
    });

    if (response.data.success) {
      dispatch(alertSuccess('Commission updated successfully'));
    }
  } finally {
    setActivationLoading({ commission: false });
  }
};
